if (!customElements.get('mobile-purchase-action')) {
  customElements.define('mobile-purchase-action', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.mobile-purchase-action__bar');
      this.mobile = window.matchMedia('(max-width: 1023px)');
      this.viewport = window.visualViewport;
      this.events = new AbortController();
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      const options = { passive: true, signal: this.events.signal };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      window.addEventListener('pageshow', this.schedule, options);
      this.viewport?.addEventListener('resize', this.schedule, options);
      this.viewport?.addEventListener('scroll', this.schedule, options);
      this.mobile.addEventListener('change', this.schedule, options);
      document.addEventListener('focusin', this.schedule, options);
      document.addEventListener('focusout', this.schedule, options);
      this.resize = new ResizeObserver(this.schedule);
      this.resize.observe(this.bar);
      this.resize.observe(this.closest('boxed-product'));
      this.update();
    }

    disconnectedCallback() {
      this.events.abort();
      this.resize.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      document.documentElement.style.removeProperty('--mobile-purchase-clearance');
    }

    update() {
      const viewport = this.viewport;
      const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
      const inset = Math.max(0, window.innerHeight - viewportBottom);
      this.bar.style.setProperty('--purchase-viewport-inset', `${inset}px`);
      const gap = parseFloat(getComputedStyle(this.bar).bottom) - inset;
      const slot = this.getBoundingClientRect();
      const height = this.bar.offsetHeight;
      const editing = document.activeElement?.matches('input:not([type="hidden"]), textarea, select, [contenteditable]:not([contenteditable="false"])');
      const product = this.closest('boxed-product');
      const withinProduct = !product.hasAttribute('data-product-embed') || product.getBoundingClientRect().top <= 90;
      const floating = this.mobile.matches && !editing && (!viewport || viewport.scale === 1)
        && withinProduct
        && slot.width > 0 && slot.top + height > viewportBottom - gap;

      this.style.height = floating ? `${height}px` : '';
      this.bar.style.setProperty('--purchase-left', `${slot.left}px`);
      this.bar.style.setProperty('--purchase-width', `${slot.width}px`);
      this.classList.toggle('is-floating', floating);
      if (floating) {
        document.documentElement.style.setProperty('--mobile-purchase-clearance', `${height + gap + inset + 12}px`);
      } else {
        document.documentElement.style.removeProperty('--mobile-purchase-clearance');
      }
    }
  });
}
